import { Injectable } from '@angular/core';
import {
    CanActivate, Router,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    CanActivateChild,
    NavigationExtras,
    CanLoad, Route
} from '@angular/router';
import { ServiceGuard } from './service.guard';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private _router: Router, private _serviceGuard: ServiceGuard) {

    }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (this._serviceGuard.loggedIn()) {
            // logged in so return true
            return true;
        }
        this._router.navigate(['/gdpr'], { queryParams: { returnUrl: state.url } });
        return false;
    }


}
